//@ts-nocheck
import React from "react";
import { View, Text, Dimensions, StyleSheet } from "react-native-web"
import { ITabProps } from "./SwipeableTabs";

const { height } = Dimensions.get("window")
const width=Math.floor(height*8.25/16)
export default function TabBar({ labels, tabCount, selectedIndex, onPress }: ITabProps) {

    let labelArray = [...Array(tabCount)].map((_, i) => i)

    // let maxlength=Math.max(...labels.map(l=>l.length))
    return (
        <View style={styles.body} >
            {
                labelArray.map(index => {
                    let label = labels[index] || '?'
                    return (<Text onPress={() => { !!onPress && onPress(index) }} style={selectedIndex == index ? {width:70,textAlign:'center', color: "black" } : {width:70,textAlign:'center',justifyContent:"flex-center" , color: "gray" }} key={index}>
                        {label}
                    </Text>)

                })
            }
        </View>
    )
}

const styles = StyleSheet.create({
    body:
    {
        flexDirection: "row",
        justifyContent: "space-between",
        width,
        maxWidth:width,
        overflow:"hidden",
        height: height * .8,
        
        backgroundColor: "white",
        paddingTop: height * 0.02,
       paddingHorizontal: width * 0.05
    },
}
)